module.exports = __webpack_public_path__ + "static/media/scanner_beep.b281c27f.ogg";